import { FacebookIcon, InstagramIcon, MapPinIcon, MessageCircleIcon, SmartphoneIcon } from "lucide-react";
import type { IconComponent } from "../../ui/icon";
import { SocialPlatform } from "../../core/types/social";
const icons: Record<SocialPlatform, IconComponent> = {
  'Instagram-post': InstagramIcon,
  'Instagram-story': SmartphoneIcon,
  Facebook: FacebookIcon,
  'WhatsApp-status': MessageCircleIcon,
  'Google-profiel': MapPinIcon
};

/** Klein kanaal-icoon met de naam als tooltip en voor schermlezers. */
export function PlatformIcon({
  platform,
  className = 'h-3.5 w-3.5'
}: {
  platform: SocialPlatform;
  className?: string;
}) {
  const Icon = icons[platform];
  return <Icon className={className} strokeWidth={1.75} aria-label={platform} role="img" data-id="element-4560" data-mp="1hp7439bggldb" />;
}

/** Rijtje icoontjes voor alle kanalen van een post. */
export function PlatformIcons({
  platforms,
  className = ''
}: {
  platforms: SocialPlatform[];
  className?: string;
}) {
  return <span className={`inline-flex items-center gap-1 text-muted ${className}`} title={platforms.join(', ')} data-id="element-4561" data-mp="2f88jz531lduh">
      {platforms.map(p => <PlatformIcon key={p} platform={p} data-id="element-4562" data-mp="2kxh5nmfazkf7" />)}
    </span>;
}